<div [dialogRef]="dialog" (appClickOutside)="close()">
  <kendo-dialog-titlebar (close)="close()">
    <ng-container>
      <div class="modal-title">
        <span>Sage Class Selection</span>
        <div class="modal-subtitle">Investigation# {{ investigation?.nefcoNumber || investigation?.id }}</div>
      </div>
    </ng-container>
  </kendo-dialog-titlebar>
  <div class="model-body">
    <p>{{ rows.length > 1 ? 'The company classes below are not' : 'The company class below is not' }} linked with SAGE. For
      each one you can either select an existing SAGE class from its list or create a new class in SAGE.</p>

    <section class="sage-row" *ngFor="let row of rows; let i = index">
      <div class="sage-row-header">
        <h4 class="mb-0">{{ row.company?.name }}</h4>
        <span class="sage-row-status done" *ngIf="row.status === 'done'">
          <i class="fa-solid fa-circle-check" aria-hidden="true"></i> Linked
        </span>
        <span class="sage-row-status" *ngIf="row.status === 'saving'">
          <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i> Saving
        </span>
      </div>

      <p class="text-danger" *ngIf="row.loadError">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ row.loadError }}
      </p>

      <kendo-gridlayout [rows]="['auto']" [gap]="{rows: 5, cols: 16}" [cols]="['repeat(5,minmax(0,1fr))']">
        <ng-container *ngFor="let item of row.sageClasses">
          <kendo-gridlayout-item class="detail radio-item">
            <div class="kendo-radio">
              <input kendoRadioButton [name]="'sageKey' + i" [(ngModel)]="row.selectedSageId" type="radio"
                [value]="item?.id" [disabled]="row.status === 'done' || isSaving" />
            </div>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item class="detail" [colSpan]="2">
            <span>
              Sage ID
            </span>
            <p>
              {{item?.id}}
            </p>
          </kendo-gridlayout-item>
          <kendo-gridlayout-item class="detail" [colSpan]="2">
            <span>
              Class Name
            </span>
            <p>
              {{item?.name}}
            </p>
          </kendo-gridlayout-item>
        </ng-container>
        <kendo-gridlayout-item class="detail radio-item" [colSpan]="5">
          <div class="kendo-radio">
            <input kendoRadioButton [name]="'sageKey' + i" [id]="'sageNewClass' + i" type="radio"
              [(ngModel)]="row.selectedSageId" [value]="'NEW'" [disabled]="row.status === 'done' || isSaving" />
            <kendo-label class="k-checkbox-label font-weight-600 checkbox-margin" style="margin-bottom: 0"
              [for]="'sageNewClass' + i" text="Create new class in SAGE"></kendo-label>
          </div>
        </kendo-gridlayout-item>
      </kendo-gridlayout>

      <p class="text-danger mb-0" *ngIf="row.error">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i> {{ row.error }}
      </p>
    </section>
  </div>
  <kendo-dialog-actions layout="end">
    <button kendoButton [size]="'medium'" themeColor="light" class="mr-16" (click)="close()">Cancel</button>
    <button kendoButton [size]="'medium'" themeColor="primary" class="mr-16" [disabled]="!canSave"
      (click)="submit()">Save</button>
  </kendo-dialog-actions>
</div>
